import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RetailIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_497_2844)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12 13.0001H5.38667C5.15027 13.0003 4.9214 12.9167 4.74073 12.7641C4.56013 12.6115 4.4394 12.3999 4.4 12.1668L2.66667 1.83346C2.6266 1.59574 2.50193 1.38051 2.31573 1.22739C2.12953 1.07426 1.89433 0.993555 1.65333 1.00013H0.986666",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.791 15.0066C10.9291 15.0066 11.041 14.8947 11.041 14.7566C11.041 14.6185 10.9291 14.5066 10.791 14.5066",
                        stroke: "#6161FF",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.791 15.0066C10.6529 15.0066 10.541 14.8947 10.541 14.7566C10.541 14.6185 10.6529 14.5066 10.791 14.5066",
                        stroke: "#6161FF",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M5.74316 15.0066C5.88123 15.0066 5.99316 14.8947 5.99316 14.7566C5.99316 14.6185 5.88123 14.5066 5.74316 14.5066",
                        stroke: "#6161FF",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M5.74316 15.0066C5.6051 15.0066 5.49316 14.8947 5.49316 14.7566C5.49316 14.6185 5.6051 14.5066 5.74316 14.5066",
                        stroke: "#6161FF",
                        strokeWidth: "1.25"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M3.99954 10H12.0795C12.5219 9.9956 12.9503 9.84467 13.2977 9.57087C13.6451 9.297 13.8919 8.91573 13.9995 8.48667L14.9862 4.62C15.003 4.54639 15.0033 4.46999 14.9872 4.39625C14.971 4.32249 14.9388 4.25321 14.8929 4.19333C14.8463 4.13335 14.7867 4.08477 14.7185 4.05127C14.6504 4.01777 14.5755 4.00024 14.4995 4H3.01287",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4.00012 4.00028L6.50012 1.50028C6.73606 1.2666 7.05472 1.1355 7.38679 1.1355C7.71886 1.1355 8.03752 1.2666 8.27346 1.50028L10.7734 4.00028",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.99333 2.22649L11.9267 1.36649C12.0838 1.31959 12.2487 1.30433 12.4118 1.32158C12.5748 1.33883 12.7329 1.38826 12.8767 1.46701C13.0206 1.54575 13.1474 1.65224 13.2498 1.78032C13.3522 1.90839 13.4282 2.05551 13.4733 2.21316L14 3.99983",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_497_2844",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "matrix(-1 0 0 1 16 0)"
                    })
                })
            })
        ]
    });
